package floris.graphics.landing.pages

import floris.graphics.core.utils.MVI
import floris.graphics.models.domain.models.Category
import floris.graphics.models.domain.models.Techstack
import floris.graphics.models.domain.models.project.Project

interface HomeContract : MVI<HomeContract.State, HomeContract.Intent, HomeContract.Effect> {
    data class State(
        val queryCategoryId: String? = null,
        val projects: List<Project> = emptyList(),
        val techStacks: List<Techstack> = emptyList(),
        val categories: List<Category> = emptyList(),
        val errorText: String = ""
    )

    sealed class Intent {
        data object LoadInitialData : Intent()
        data class SelectCategory(val categoryId: String?) : Intent()
        data class Navigate(val route: String) : Intent()
    }

    sealed class Effect {
        data class Navigate(val route: String) : Effect()
    }
}
